<template>
  <div class="app">
    <!-- <keep-alive>
      <router-view />
    </keep-alive> -->
    <!-- <router-view v-slot="{ Component }">
      <keep-alive>
        <component :is="Component" />
      </keep-alive>
    </router-view> -->
    <router-view></router-view>
  </div>
</template>
<script>
import { mapGetters,mapMutations } from "vuex";
import { h5ObtainProfile } from '@/utils/hybrid';
import { lang } from "../i18n"
import platform from "@/utils/platform"

// import _TDID from 'TDID'
export default {
  name: "App",
  computed: {
    ...mapGetters(["profile"]),
  },
  methods: {
    ...mapMutations(["SET_DEVICETOKEN"]),
    isIOSApp() {
      // 1: 安卓 2: IOS
      h5ObtainProfile().then(res => {
        if (platform() === 2 && res.device) {
          this.$router.replace('/notfound')
          window.document.title = 'not found'
        } else {
          window.document.title = this.$t['title']
          if (/^ar/.test(lang)) {
            window.document.documentElement.dir = 'rtl'
            window.document.documentElement.lang = 'ar'
          }
        }
      }).catch((err) => {
        console.log(err)
        window.document.title = this.$t['title']
        if (/^ar/.test(lang)) {
          window.document.documentElement.dir = 'rtl'
          window.document.documentElement.lang = 'ar'
        }
      })
    }
  },
  created() {
    this.isIOSApp();
  },
  inject: ["$t"],
  mounted() {
    window.document.title = this.$t.title;
    const that = this;
    // _TDID.init(
    //   {
    //     channel: 100049,
    //     apiUrl: CONFIG.DOMAIN.TDID_URL,
    //   },
    //   null,
    // )

    // _TDID.getDeviceToken(function (res) {
    //   if (res.ret === 0) {
    //     that.SET_DEVICETOKEN(res.deviceToken)
    //   } else {
    //     showToast({
    //       message: 'Error! Get DeviceToken, Code: ' + res.ret + ' !',
    //       duration: 5000,
    //     })
    //   }
    // })
  },
};
</script>
<style>
html,
body,
#app {
  height: 100%;
}

.app {
  height: 100%;
  max-width: 768px;
  margin: 0 auto;
  overflow-y: auto;
}
</style>
